import React from "react";

const FeatureCard = ({ imageSrc, imageAlt, title, description }) => {
  return (
    <div className="flex flex-col items-center py-[10px] lg:py-[24px] px-[50px]">
      <div className="mb-4 bg-[#805AED] rounded-full p-3 flex items-center justify-center">
        <img src={imageSrc} alt={imageAlt} width={120} height={120} />
        {/* <Image src={imageSrc} alt={imageAlt} width={50} height={50} /> */}
      </div>
      <p className="font-semibold text-[20px] text-[#444C5E] mt-4 text-center">
        {title}
      </p>
      <p className="font-normal text-[16px] text-[#444C5E] mt-2 text-center">
        {description}
      </p>
    </div>
  );
};

export default FeatureCard;
